import { homeConstants } from "../constants";

const hasUserSelectedInsurance = localStorage.getItem(
  "hasUserSelectedInsurance"
);

export default function (
  state = {
    items: [],
    isProgress: false,
    data: [],
    selectedInsurance: "",
    hasUserSelectedInsurance: !hasUserSelectedInsurance
      ? "N"
      : hasUserSelectedInsurance,
  },
  action
) {
  switch (action.type) {
    case homeConstants.PRODUCT_INSURANCE_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.PRODUCT_INSURANCE_SUCCESS: {
      if (action.response.data && action.response.data.length > 100) {
        action.response.data = action.response.data.slice(0, 100);
      }
      return {
        ...state,
        data: action.response.data,
        isProgress: false,
      };
    }
    case homeConstants.PRODUCT_INSURANCE_FAILURE:
      return {
        ...state,
        data: [],
        error: action.error,
        isProgress: false,
      };
    case homeConstants.PRODUCT_INSURANCE_RESET:
      return {
        ...state,
        data: [],
        isProgress: false,
      };
    case homeConstants.SELECTED_INSURANCE: {
      localStorage.setItem(
        "storedInsuranceData",
        JSON.stringify(action.insurance)
      );
      return {
        ...state,
        hasUserSelectedInsurance: action.insurance.type !== "W" ? "Y" : "N",
        selectedInsurance: action.insurance,
      };
    }
    case homeConstants.RESET_SELECTED_INSURANCE: {
      localStorage.removeItem("storedInsuranceData");
      return {
        ...state,
        selectedInsurance: "",
      };
    }
    default:
      return state;
  }
}
